import { render } from "./SubscriptionMessageTemplateModal.vue?vue&type=template&id=da554a52&scoped=true"
import script from "./SubscriptionMessageTemplateModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionMessageTemplateModal.vue?vue&type=script&lang=js"

import "./SubscriptionMessageTemplateModal.vue?vue&type=style&index=0&id=da554a52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da554a52"]])

export default __exports__